import {
  Header,
  Hero,
  About,
  Resume,
  Portfolio,
  Contact,
  Blogs,
  Footer,
} from "./app/components/sections";

function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Resume />
      <Portfolio />
      <Blogs />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
